module.exports = require("@wordpress/icons");